export const tiposServicioKeys = {
  all: ['tipos-servicio'] as const,
  lists: () => [...tiposServicioKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...tiposServicioKeys.lists(), filters] as const,
  details: () => [...tiposServicioKeys.all, 'detail'] as const,
  detail: (id: number) => [...tiposServicioKeys.details(), id] as const,
};
